import { useEffect, useReducer, useState } from "react";

function reducer(state, action) {
  switch (action.type) {
    case "HIDE_COLUMN": {
      return {
        ...state,
        hiddenColumns: [...state.hiddenColumns, action.colName],
      };
    }
    case "SHOW_COLUMN": {
      return {
        ...state,
        hiddenColumns: state.hiddenColumns.filter(
          (colName) => colName !== action.colName
        ),
      };
    }
    default: {
      return state;
    }
  }
}

const useTableOptions = (tableName) => {
  const [isNew, setIsNew] = useState(false);
  const tblOptionsJSON = localStorage.getItem(tableName);

  let tblOptionsInitState = {
    hiddenColumns: [],
  };

  useEffect(() => {
    if (tblOptionsJSON === null) {
      setIsNew(true);
    }
  }, [tblOptionsJSON]);

  try {
    let tblOptions = JSON.parse(tblOptionsJSON);
    if (tblOptions != null) {
      tblOptionsInitState = tblOptions;
    }
  } catch (err) {}

  const [tableState, dispatch] = useReducer(reducer, tblOptionsInitState);

  const handleColumnShow = (colName, action) => {
    if (action === "add") {
      dispatch({ type: "SHOW_COLUMN", colName: colName });
    } else if (action === "remove") {
      dispatch({ type: "HIDE_COLUMN", colName: colName });
    }
  };

  const isColDisplayed = (colName) => {
    let displayCol = true;
    for (let i = 0; i < tableState.hiddenColumns.length; i++) {
      if (tableState.hiddenColumns[i] === colName) {
        displayCol = false;
        break;
      }
    }

    return displayCol;
  };

  useEffect(() => {
    try {
      window.localStorage.setItem(tableName, JSON.stringify(tableState));
    } catch (err) {}
  }, [tableState, tableName]);

  return { tableState, handleColumnShow, isColDisplayed, dispatch, isNew };
};

export default useTableOptions;
